import React, { useEffect, useState } from "react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchTeacherTimetable } from "../TimeTable/redux/myTimetableSlice";
import { fetchSessionsThunk } from "../../AcademicCalendar/redux/academicCalendarSlice";
import { getSyllabusScheduleThunk, getSyllabusThunk, shiftTopicThunk } from "../redux/syllabusthunk";
import "./ShowLessons.css";
import testSyllabus from "../Syllabus";
import {
  clearPopupInfo,
  closeHwPopup,
  closeProjectPopup,
  closeRemarksPopup,
  setHwPopup,
  setPopupInfo,
  setProjectsPopup,
  setRemarksPopup,
} from "./redux/topicSlice";
import Popup from "../../EventOrganiser/Popup";
import TopicForm from "./TopicForm";
import RemarksForm from "./RemarksForm";
import ProjectForm from "./ProjectForm";
import HomeWorkForm from "./HomeWorkForm";
import { fetchTeacherHomework, getAllTopicsThunk, updateTopicStatusThunk } from "./redux/topicReducer";
import AllProjects from "./Projects/AllProjects";
import { fetchTeacherProjects } from "../Projects/redux/projectThunk";
import userStore from "../../../zustand/userStore";
import { setStepIndex, setStepValid, stopTour, startTour } from "../../../redux/globalJoyrideSlice";
import { weeklyLessonsTourSteps, topicFormTourSteps } from "../../../tour/teacherPlanerTourSteps";
import LessonsTable from "../components/LessonsTable";

export default function ShowLessons() {
  const dispatch = useDispatch();
  const { syllabusSchedule } = useSelector((state) => state.syllabus);
  const { teacherPeriods, loading } = useSelector((state) => state.myTimetable);

  const { isOpen, isRemark, isProject, isHomeWork, allTopics, HwData } =
    useSelector((state) => state.topic);

  console.log("allTopics", allTopics);
  const sessions = useSelector((state) => state.academicCalendar.sessions);
  const { teacherProjects } = useSelector((state) => state.project);

  const [chapterPlan, setChapterPlan] = useState([]);
  const [weeks, setWeeks] = useState([]);
  const [formData, setFormData] = useState({
    selectedClass: "",
    selectedSubject: "",
    selectedSection: "",
    noData: false,
  });
  const [currentRangeStart, setCurrentRangeStart] = useState(moment().startOf("isoWeek"));
  const [expandedRows, setExpandedRows] = useState({});
  const [statusPopup, setStatusPopup] = useState({
    isOpen: false,
    rowData: null, // Default to In Progress
    reason: "",
    incompletePreviousPeriods: [],
  });
  const userData = userStore((state) => state.user);
  const teacher_id = userData?.teacher_id;
  const navigate = useNavigate();

  console.log("teacher_id", teacher_id);
  const { stepIndex, run } = useSelector(
    (state) => state.globalJoyride
  );


  useEffect(() => {
    if (teacher_id) {
      dispatch(fetchSessionsThunk());
      dispatch(getSyllabusScheduleThunk(teacher_id));
      dispatch(fetchTeacherTimetable(teacher_id));
      dispatch(getAllTopicsThunk({ teacher_id: teacher_id, school_id: 1 }));
      dispatch(fetchTeacherHomework({ teacher_id: teacher_id, school_id: 1 }));
      dispatch(fetchTeacherProjects({ teacher_id: teacher_id, school_id: 1 }));
    }
  }, [dispatch, teacher_id]);
  useEffect(() => {
    if (teacherPeriods?.classes?.length > 0) {
      setTimeout(() => {
        dispatch(setStepIndex(1));
      }, 100);
    }
  }, [teacherPeriods.classes]);

  useEffect(() => {
    // start tour only once, after teacher data is available
    if (
      teacherPeriods?.classes?.length > 0 &&
      !run
    ) {
      dispatch(
        startTour({
          activeTour: "weekly-lessons",
          steps: weeklyLessonsTourSteps({
            dispatch, navigate,
            stopTour: () => dispatch(stopTour()),
          }),
          stepIndex: 1,
        })
      );

    }
  }, [teacherPeriods.classes, run, dispatch]);


  useEffect(() => {
    if (isOpen) {
      dispatch(
        startTour({
          activeTour: "topic-form",
          steps: weeklyLessonsTourSteps({
            dispatch, navigate,
            stopTour: () => dispatch(stopTour()),
          }),
          stepIndex: 6,
        })
      );
    }

    if (isHomeWork) {
      dispatch(
        startTour({
          activeTour: "topic-form",
          steps: weeklyLessonsTourSteps({
            dispatch, navigate,
            stopTour: () => dispatch(stopTour()),
          }),
          stepIndex: 9,
        })
      );
    }


  }, [isOpen, isHomeWork, dispatch]);

  // useEffect(() => {
  //   if (
  //     !(teacherPeriods?.classes?.length > 0) ||
  //     !(teacherPeriods.subjects?.length > 0)
  //   )
  //     return;

  //   const selectedClassId = formData.selectedClass;
  //   const selectedSubjectId = formData.selectedSubject;

  //   const session = sessions.find((s) => s.status === "active");
  //   if (!session) return;

  //   const start = moment(session.start_date);
  //   const end = moment(session.end_date);
  //   const totalDays = end.diff(start, "days") + 1;

  //   const allDates = Array.from({ length: totalDays }, (_, i) => {
  //     const date = start.clone().add(i, "days");
  //     return { date, dayName: date.format("dddd") };
  //   });

  //   const periods = teacherPeriods?.periods || [];

  //   // 🔄 Get all relevant syllabi (filtered or all)
  //   const filteredSyllabi = Array.isArray(syllabusSchedule)
  //     ? syllabusSchedule.filter((item) => {
  //       const classMatch = selectedClassId
  //         ? String(item.class_id) === selectedClassId
  //         : true;
  //       const subjectMatch = selectedSubjectId
  //         ? String(item.subject_id) === selectedSubjectId
  //         : true;
  //       return classMatch && subjectMatch;
  //     })
  //     : [];

  //   // 📦 Build sectionPlans for all matched syllabi
  //   const sectionPlans = [];

  //   for (const syllabus of filteredSyllabi) {
  //     const matchedClass = teacherPeriods.classes.find(
  //       (cls) => cls.class_id === syllabus.class_id
  //     );

  //     // const sectionList = matchedClass?.sections || [];
  //     const sectionList =
  //       matchedClass?.sections?.filter((section) =>
  //         formData.selectedSection
  //           ? section.section_id == formData.selectedSection
  //           : true
  //       ) || [];

  //     const chapters = syllabus?.syllabus ? JSON.parse(syllabus.syllabus) : [];

  //     const subjectPeriods = periods.filter(
  //       (p) =>
  //         Number(p.subject_id) === Number(syllabus.subject_id) &&
  //         sectionList.some((section) => section.section_id === p.section_id)
  //     );

  //     const sectionWiseFlatPeriods = sectionList.map((section) => {
  //       const filteredPeriods = subjectPeriods.filter(
  //         (p) => p.section_id === section.section_id
  //       );

  //       const flatPeriods = [];

  //       allDates.forEach(({ date, dayName }) => {
  //         filteredPeriods
  //           .filter((p) => p.day === dayName)
  //           .forEach((p) =>
  //             flatPeriods.push({
  //               ...p,
  //               date: date.format("YYYY-MM-DD"),
  //             })
  //           );
  //       });

  //       const midDate = start
  //         .clone()
  //         .add(totalDays / 2, "days")
  //         .startOf("day");

  //       const term1Periods = flatPeriods.filter((p) =>
  //         moment(p.date).isSameOrBefore(midDate, "day")
  //       );
  //       const term2Periods = flatPeriods.filter((p) =>
  //         moment(p.date).isAfter(midDate, "day")
  //       );

  //       return {
  //         section_id: section.section_id,
  //         section_name: section.section_name,
  //         term1Periods,
  //         term2Periods,
  //       };
  //     });

  //     const term1Chapters = chapters.filter((ch) => ch.termId === 1);
  //     const term2Chapters = chapters.filter((ch) => ch.termId === 2);

  //     const allocatePeriods = (termChapters, termPeriodList, label) => {
  //       const tempPlan = [];
  //       let i = 0;
  //       termChapters.forEach((chapter) => {
  //         for (let j = 0; j < Number(chapter.numberofperiods); j++) {
  //           if (i >= termPeriodList.length) break;
  //           tempPlan.push({
  //             sno: tempPlan.length + 1,
  //             period: termPeriodList[i],
  //             className: termPeriodList[i].class_name,
  //             class_id: syllabus.class_id,
  //             subjectName: termPeriodList[i].subject_name,
  //             chapter: chapter.chapter,
  //             homework: "",
  //           });
  //           i++;
  //         }
  //       });

  //       // Remaining periods as Revision
  //       for (; i < termPeriodList.length; i++) {
  //         tempPlan.push({
  //           sno: tempPlan.length + 1,
  //           period: termPeriodList[i],
  //           className: termPeriodList[i].class_name,
  //           class_id: syllabus.class_id,
  //           subjectName: termPeriodList[i].subject_name,
  //           chapter: `Revision (${label})`,
  //           homework: "",
  //         });
  //       }

  //       return tempPlan;
  //     };

  //     sectionWiseFlatPeriods.forEach((section) => {
  //       const term1Plan = allocatePeriods(
  //         term1Chapters,
  //         section.term1Periods,
  //         "Term 1"
  //       );
  //       const term2Plan = allocatePeriods(
  //         term2Chapters,
  //         section.term2Periods,
  //         "Term 2"
  //       );

  //       sectionPlans.push({
  //         section_id: section.section_id,
  //         section_name: section.section_name,
  //         term1Plan,
  //         term2Plan,
  //       });
  //     });
  //   }

  //   // 🌐 Full plan (all sections)
  //   if (sectionPlans.length > 0) {
  //     const fullPlan = sectionPlans.flatMap((section) => [
  //       ...section.term1Plan,
  //       ...section.term2Plan,
  //     ]);

  //     const groupedWeeks = {};
  //     fullPlan.forEach((item) => {
  //       const weekStart = moment(item.period.date)
  //         .startOf("isoWeek")
  //         .format("YYYY-MM-DD");
  //       if (!groupedWeeks[weekStart]) groupedWeeks[weekStart] = [];
  //       groupedWeeks[weekStart].push(item);
  //     });

  //     const sortedWeekStartDates = Object.keys(groupedWeeks)
  //       .map((d) => moment(d))
  //       .sort((a, b) => a.diff(b));

  //     const weeklyData = sortedWeekStartDates.map(
  //       (m) => groupedWeeks[m.format("YYYY-MM-DD")]
  //     );

  //     setWeeks(weeklyData);
  //     setChapterPlan(fullPlan);

  //     const today = moment();
  //     const startOfThisWeek = today.clone().startOf("isoWeek");

  //     const sessionStart = moment(session.start_date).startOf("day");
  //     const sessionEnd = moment(session.end_date).endOf("day");

  //     const validStart = startOfThisWeek.isBefore(sessionStart)
  //       ? sessionStart
  //       : startOfThisWeek;

  //     const clampedStart = validStart.isAfter(sessionEnd)
  //       ? sessionEnd.clone().startOf("isoWeek")
  //       : validStart;

  //     setCurrentRangeStart(clampedStart.startOf("isoWeek"));
  //     setFormData((prev) => ({ ...prev, noData: fullPlan.length === 0 }));
  //   } else {
  //     setChapterPlan([]);
  //     setWeeks([]);
  //     setFormData((prev) => ({ ...prev, noData: true }));
  //   }
  // }, [
  //   syllabusSchedule,
  //   sessions,
  //   teacherPeriods,
  //   formData.selectedClass,
  //   formData.selectedSubject,
  //   formData.selectedSection,
  // ]);
  if (!userData?.teacher_id) {
    return (
      <Popup
        title="Access Restricted"
        height="300px"
        maxWidth="500px"
        onClose={() => window.history.back()}
        minHeight="200px"
      >
        <div className="text-center p-4">
          <h3 className="text-xl font-bold mb-3">
            ⚠️ Teacher Assignment Needed
          </h3>
          <p className="mb-4">
            You are not yet assigned as a teacher. Please contact the
            administrator to get a teacher ID before viewing your timetable.
          </p>
          <button
            className="btn btn-primary"
            onClick={() => window.history.back()}
          >
            Go Back
          </button>
        </div>
      </Popup>
    );
  }
  const handleChange = (e) => {
    const { name, value } = e.target;
    // setFormData((prev) => ({ ...prev, [name]: value }));
    if (name === "selectedClass") {
      setFormData((prev) => ({
        ...prev,
        selectedClass: value,
        selectedSection: "",
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handlePrevWeek = () => {
    const newStart = currentRangeStart.clone().subtract(1, "week");
    const sessionStart = moment(
      sessions.find((s) => s.status === "active")?.start_date
    ).startOf("isoWeek");

    if (newStart.isSameOrAfter(sessionStart)) {
      setCurrentRangeStart(newStart);
    }
  };

  const handleNextWeek = () => {
    const newStart = currentRangeStart.clone().add(1, "week");
    const sessionEnd = moment(
      sessions.find((s) => s.status === "active")?.end_date
    ).endOf("isoWeek");

    if (newStart.isSameOrBefore(sessionEnd)) {
      setCurrentRangeStart(newStart);
    }
  };
  const formattedSchedule = (syllabusSchedule || []).map((item, index) => {

    const matchedTopic = allTopics.find(
      (topic) => String(topic.schedule_id) === String(item.schedule_id)
    );

    return {
      sno: index + 1,
      schedule_id: item.schedule_id,
      chapter: item.chapter || "Revision",

      className: item.class_name ?? "-",
      subjectName: item.subject_name ?? "-",

      class_id: item.class_id ?? "",
      section_id: item.section_id ?? "",
      subject_id: item.subject_id ?? "",

      status: matchedTopic?.status ?? item.status ?? "3",

      period: {
        date: moment.utc(item.date).format("YYYY-MM-DD"),
        period_name: item.period_details?.period_name ?? "-",
        section_id: item.section_id ?? "",
        subject_id: item.subject_id ?? ""
      },

      topic: item.topic_details?.topic_name ?? "",
      topic_id: item.topic_details?.topic_id ?? null,   // ✅ FIX 
      homework: item.homework_details?.homework_title ?? "",
      homework_id: item.homework_details?.homework_id ?? null,
    };
  });

  const handleStatusIconClick = (row) => {
    const matched = allTopics.find((topic) => {
      return (
        String(topic.class_id) === String(row.class_id) &&
        String(topic.section_id) === String(row.period?.section_id) &&
        String(topic.subject_id) === String(row.period?.subject_id) &&
        String(topic.period_number) === String(row.sno) &&
        String(topic.chapter_name).trim() === String(row.chapter).trim()
      );
    });

    const currentDate = moment(row.period.date).startOf("day");

    const incompletePreviousPeriods = formattedSchedule.filter((item) => {
      const itemDate = moment(item.period.date).startOf("day");

      const isSameCategory =
        String(item.class_id) === String(row.class_id) &&
        String(item.period.section_id) === String(row.period?.section_id) &&
        String(item.period.subject_id) === String(row.period?.subject_id);

      const isPreviousDate = itemDate.isBefore(currentDate);

      const isSameDayPreviousPeriod =
        itemDate.isSame(currentDate) &&
        Number(item.sno) < Number(row.sno);

      const isSameRow =
        item.period.date === row.period.date &&
        item.sno === row.sno;

      if (!isSameCategory || isSameRow) return false;

      if (!(isPreviousDate || isSameDayPreviousPeriod)) return false;

      const topicRecord = allTopics.find((topic) =>
        String(topic.class_id) === String(item.class_id) &&
        String(topic.section_id) === String(item.period?.section_id) &&
        String(topic.subject_id) === String(item.period?.subject_id) &&
        String(topic.period_number) === String(item.sno) &&
        String(topic.chapter_name).trim() === String(item.chapter).trim()
      );

      const status = topicRecord?.status
        ? String(topicRecord.status)
        : String(item.status || "3");

      return status === "3";
    });

    setStatusPopup({
      isOpen: true,
      rowData: row,
      selectedStatus: matched?.status ? String(matched.status) : "3",
      reason: matched?.reason || "",
      incompletePreviousPeriods, // ✅ pass them along
    });
  };

  const handleStatusSubmit = async () => {
    const { rowData, selectedStatus, reason, incompletePreviousPeriods } = statusPopup;

    if (incompletePreviousPeriods?.length > 0) {
      const firstIncomplete = incompletePreviousPeriods[0];

      alert(
        `⚠️ Please update the status of previous periods first.\n\n` +
        `Pending: "${firstIncomplete.chapter}" - ${firstIncomplete.period.date} (Period: ${firstIncomplete.period.period_name})\n\n` +
        `You have ${incompletePreviousPeriods.length} previous period(s) still "In Progress".`
      );

      setStatusPopup({
        isOpen: true,
        rowData: firstIncomplete,
        selectedStatus: "3",
        reason: "",
        incompletePreviousPeriods: incompletePreviousPeriods.slice(1),
      });

      return;
    }

    try {
      // ✅ update status
      await dispatch(updateTopicStatusThunk({
        schedule_id: rowData.schedule_id,
        status: selectedStatus,
        reason: selectedStatus == "1" ? reason : null,
      })).unwrap();

      // ✅ shift if needed
      if (selectedStatus === "1") {
        await dispatch(shiftTopicThunk({
          teacherId: teacher_id,
          absentDate: rowData.period.date,
          classId: rowData.class_id,
          sectionId: rowData.section_id || rowData.period?.section_id || null,
          subjectId: rowData.period.subject_id,
        })).unwrap();
      }

      // 🔥 MAIN FIX — REFRESH BOTH
      await Promise.all([
        dispatch(getAllTopicsThunk({
          teacher_id: teacher_id,
          school_id: 1,
        })),
        dispatch(getSyllabusScheduleThunk(teacher_id))
      ]);

      // ✅ close popup AFTER refresh
      setStatusPopup({
        isOpen: false,
        rowData: null,
        selectedStatus: "3",
        reason: "",
        incompletePreviousPeriods: [],
      });

    } catch (err) {
      alert("Failed to update status: " + err.message);
    }
  };

  // const currentWeekData = weeks.find((weekItems) => {
  //   const firstDate = moment(weekItems[0]?.period?.date).startOf("isoWeek");
  //   return firstDate.isSame(currentRangeStart, "day");
  // });

  const weekStart = currentRangeStart.clone().startOf("isoWeek");
  const weekEnd = currentRangeStart.clone().endOf("isoWeek");

  const filteredSchedule = formattedSchedule.filter((row) => {
    // ✅ Class match
    let classMatch = true;
    if (formData.selectedClass) {
      const selectedClassObj = teacherPeriods.classes.find(
        (c) => String(c.class_id) === String(formData.selectedClass)
      );

      classMatch = row.className
        ?.toLowerCase()
        .includes(selectedClassObj?.class_name?.toLowerCase());
    }

    // ✅ Section match
    let sectionMatch = true;
    if (formData.selectedSection) {
      const selectedClassObj = teacherPeriods.classes.find(
        (c) => String(c.class_id) === String(formData.selectedClass)
      );

      const selectedSectionObj = selectedClassObj?.sections?.find(
        (s) => String(s.section_id) === String(formData.selectedSection)
      );

      sectionMatch = row.className
        ?.toLowerCase()
        .includes(selectedSectionObj?.section_name?.toLowerCase());
    }

    // ✅ Subject match
    let subjectMatch = true;
    if (formData.selectedSubject) {
      const selectedSubjectObj = teacherPeriods.subjects.find(
        (s) => String(s.subject_id) === String(formData.selectedSubject)
      );

      subjectMatch =
        row.subjectName?.toLowerCase() ===
        selectedSubjectObj?.subject_name?.toLowerCase();
    }

    return classMatch && sectionMatch && subjectMatch;
  });

  const currentWeekData = filteredSchedule
    .filter((row) => {
      const rowDate = moment(row.period.date);
      return rowDate.isBetween(weekStart, weekEnd, "day", "[]");
    })
    .sort((a, b) => {
      const dateCompare = moment(a.period.date).diff(moment(b.period.date));
      if (dateCompare !== 0) return dateCompare;

      return a.period.period_name.localeCompare(b.period.period_name);
    });

  const handleIconClick = (type, row) => {
    // const { index, chapterPeriods } = getPeriodIndex(row, chapterPlan);
    const matchedTopic = allTopics.find(
      (topic) => String(topic.schedule_id) === String(row.schedule_id)
    );
    console.log("MATCHED TOPIC 👉", matchedTopic);
    console.log("row", row);

    const payload = {
      schedule_id: row.schedule_id,
      chapter: row.chapter,
      class_id: row.class_id,
      section_id: row.period.section_id,
      teacher_id: teacher_id,
      subject_id: row.period.subject_id,
      period_number: row.sno,
      existingTopic: row.topic
        ? {
          id: row.topic_id,
          topic: row.topic
        }
        : null,
    };

    console.log("PAYLOAD 345👉", payload);
    switch (type) {
      case "lesson":
        dispatch(setPopupInfo(payload));
        break;

      case "homework":
        dispatch(
          setHwPopup({
            ...payload,
            existingHomework: row.homework
              ? {
                id: row.homework_id,
                details: row.homework
              }
              : null,
          })
        );
        break;

      case "project":
        dispatch(setProjectsPopup(payload));
        break;

      default:
        console.warn("Unknown icon type:", type);
    }
  };

  if (loading) return <p>Loading...</p>;

  const toggleExpandRow = (rowId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [rowId]: !prev[rowId],
    }));
  };

  const findMatchForRow = (row, type) => {
    if (type === "topic") {
      const matchedTopic = allTopics.find(
        (topic) => String(topic.schedule_id) === String(row.schedule_id)
      );
      return matchedTopic?.topic || "";
    }

    if (type === "homework") {
      const matchedHw = HwData.find((hw) => {
        return (
          hw.class_id == row.class_id &&
          hw.section_id == row.period?.section_id &&
          hw.subject_id == row.period?.subject_id &&
          hw.period_number == row.sno &&
          hw.chapter_name == row.chapter
        );
      });
      return matchedHw?.details || " ";
    }
    if (type === "remarks") {
      const matched = allTopics.find((topic) => {
        return (
          topic.class_id == row.class_id &&
          topic.section_id == row.period?.section_id &&
          topic.subject_id == row.period?.subject_id &&
          topic.period_number == row.sno &&
          topic.chapter_name == row.chapter
        );
      });
      return matched?.remarks ?? " ";
    }
    if (type === "project") {
      const matchedProj = teacherProjects.find((proj) => {
        return (
          proj.class_id == row.class_id &&
          proj.section_id == row.period?.section_id &&
          proj.subject_id == row.period?.subject_id &&
          proj.period_number == row.sno &&
          proj.chapter_name?.trim().toLowerCase() ===
          row.chapter?.trim().toLowerCase()
        );
      });
      return matchedProj || null;
    }

    if (type === "status") {
      const matched = allTopics.find((topic) => {
        return (
          topic.class_id == row.class_id &&
          topic.section_id == row.period?.section_id &&
          topic.subject_id == row.period?.subject_id &&
          topic.period_number == row.sno &&
          topic.chapter_name == row.chapter
        );
      });
      console.log("476", matched?.status)
      // CHANGE: Change "1" to "3" so lessons without data show as In Progress
      return matched?.status;
    }

    return "";
  };

  return (
    <div className="px-5" style={{ fontFamily: "Segoe UI, sans-serif" }}>
      <div style={{ display: "flex", gap: 20 }}>
        <div style={styles.formGroupStyle}>
          <label style={styles.labelStyle}>Select Class</label>
          <select
            data-tour="weekly-select-class"
            name="selectedClass"
            value={formData.selectedClass}
            onChange={(e) => {
              handleChange(e);
              dispatch(setStepIndex(2));
            }}
          >
            <option value="">-- Select Class --</option>
            {teacherPeriods?.classes?.map((cls, index) => (
              <option key={index} value={cls.class_id}>
                {cls.class_name}
              </option>
            ))}
          </select>
        </div>

        <div style={styles.formGroupStyle}>
          <label style={styles.labelStyle}>Select Section</label>
          <select
            data-tour="weekly-select-section"
            name="selectedSection"
            value={formData.selectedSection}
            onChange={(e) => {
              handleChange(e);
              dispatch(setStepIndex(3));
            }}
          >
            <option value="">-- Select Section --</option>
            {teacherPeriods?.classes
              ?.find((cls) => cls.class_id == formData.selectedClass)
              ?.sections?.map((sec, idx) => (
                <option key={idx} value={sec.section_id}>
                  {sec.section_name}
                </option>
              ))}
          </select>
        </div>

        <div style={styles.formGroupStyle}>
          <label style={styles.labelStyle}>Select Subject</label>
          <select
            data-tour="weekly-select-subject"
            name="selectedSubject"
            value={formData.selectedSubject}
            onChange={(e) => {
              handleChange(e);

              // wait for table render
              setTimeout(() => {
                dispatch(setStepIndex(4));
              }, 150);
            }}
            style={styles.inputStyle}
          >
            <option value="">-- Select Subject --</option>
            {teacherPeriods?.subjects?.map((subj, index) => (
              <option key={index} value={subj.subject_id}>
                {subj.subject_name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="lesson-header-controls">
        <button className="week-button" onClick={handlePrevWeek}>
          ← Previous Week
        </button>

        {currentRangeStart && (
          <h3>
            {moment(currentRangeStart).format("MMM D, YYYY")} -{" "}
            {moment(currentRangeStart).endOf("isoWeek").format("MMM D, YYYY")}
          </h3>
        )}

        <button className="week-button" onClick={handleNextWeek}>
          Next Week →
        </button>
      </div>

      <div className="lesson-table-container" data-tour="weekly-lesson-table">

        <LessonsTable
          styles={styles}
          currentWeekData={currentWeekData || []}
          expandedRows={expandedRows}
          toggleExpandRow={toggleExpandRow}
          findMatchForRow={findMatchForRow}
          handleIconClick={handleIconClick}
          handleStatusIconClick={handleStatusIconClick}
          allTopics={allTopics}
          isOpen={isOpen}
          isHomeWork={isHomeWork}
          isProject={isProject}
          statusPopup={statusPopup}
          setStatusPopup={setStatusPopup}
          handleStatusSubmit={handleStatusSubmit}
          dispatch={dispatch}
          clearPopupInfo={clearPopupInfo}
          closeHwPopup={closeHwPopup}
          closeProjectPopup={closeProjectPopup}
        />
      </div>
    </div>
  );
}

const styles = {
  th: {
    border: "1px solid #ccc",
    padding: "10px",
    textAlign: "left",
  },
  td: {
    border: "1px solid #ccc",
    padding: "10px",
  },
  inputStyle: {
    padding: 8,
    fontSize: 14,
    borderRadius: 4,
    border: "1px solid #ccc",
    width: "100%",
    maxWidth: 400,
  },
  formGroupStyle: {
    minWidth: "25%",
    marginBottom: 15,
  },
  labelStyle: {
    fontWeight: "bold",
    marginBottom: 5,
  },
};
